import { types } from 'mobx-state-tree';

export const UnconfirmedChangeModel = types.model('UnconfirmedChange', {
  _type: types.optional(
    types.enumeration(['answer', 'no_answer'] as const),
    'answer'
  ),
  status: types.optional(
    types.enumeration(['wait', 'conflict', 'success'] as const),
    'wait'
  ),
});
